import { FeaturedLinks } from "../../../../src/components/article-elements/FeaturedLinks.tsx";
import { ShuffleSimulatorBroadcast } from 'src/components/shuffle-simulator/simulations/Broadcast.tsx';
import * as React from 'react';
export default {
  FeaturedLinks,
  ShuffleSimulatorBroadcast,
  React
};